import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #0d1117; /* main background */
    --navy: #161b22; /* panels/nav */
    --light-navy: #21262d; /* hover, card borders */
    --lightest-navy: #30363d; /* highlights */
    --navy-shadow: rgba(13, 17, 23, 0.7);

    --dark-slate: #6e7681; /* muted grey */
    --slate: #8b949e; /* secondary text */
    --light-slate: #c9d1d9; /* primary body text */
    --lightest-slate: #e6edf3; /* bright headings */
    --white: #ffffff;

    --green: #3fb950; /* success green */
    --green-tint: rgba(63, 185, 80, 0.15);
    --pink: #8957e5; /* purple accent */
    --blue: #58a6ff; /* link blue */
    --orange: #f85149; /* error/red accent */

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 72px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
